export default "__VITE_ASSET__CDx755ec__"